module.exports = __webpack_public_path__ + "img/elemento_pc_up_selected.674bbd13.svg";